import { HttpInterceptorFn } from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RefreshTokenService } from '../services/refresh-token.service';
import { inject } from '@angular/core';
import { AuthGuard } from '../auth.guard';
import { SessionService } from '../services/session.service';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { Router } from '@angular/router';
import { getBearerToken } from '../utils/auth-request.util';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const refreshTokenService = inject(RefreshTokenService);
    const sessionService = inject(SessionService);
    const authGuard = inject(AuthGuard);
    const router = inject(Router);
    const inMemoryStorageService = inject(InMemoryStorageService);
    // Exclude login and refresh endpoints from token logic
 // Public auth calls. /cognito/generate is the OTP send; do not match InvoiceAndPicklist/generateOutput.
    if (
        req.url.includes('/login') ||
        req.url.includes('/refresh-token') ||
        req.url.includes('/reset-password') ||
        req.url.includes('/cognito/generate') ||
        req.url.includes('/otp-verify') ||
        req.url.includes('/forgot-password')
    ) {
        return next(req);
    }

    const accessToken = getBearerToken();

    function isTokenExpired(token: string): boolean {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
                const expiry = payload.exp;
        

            const nowSec = Math.floor(Date.now() / 1000);
        
            const remainingSeconds = expiry - nowSec - 45 ;
            const remainingMinutes = (remainingSeconds / 60).toFixed(2);

        console.log(`🕒 Token will expire in ${remainingMinutes} minutes`);

            return remainingSeconds <= 0;
            // For production, use: return payload.exp <= nowSec;
        } catch {
            return true;
        }
    }

    if (accessToken && !isTokenExpired(accessToken)) {
        // Token is valid, proceed as normal
        console.debug('[authInterceptor] Using existing auth_token for', req.url, accessToken ? accessToken.slice(0, 12) + '...' : 'no-token');
        const cloned = req.clone({
            setHeaders: { Authorization: `Bearer ${accessToken}` }
        });
        return next(cloned);
    }

    // Token is invalid, try refresh
    return from(refreshTokenService.refreshToken()).pipe(
        switchMap((success) => {
            if (success) {
                const newToken = getBearerToken();
                console.debug('[authInterceptor] Refreshed auth_token for', req.url, newToken ? newToken.slice(0, 12) + '...' : 'no-token');
                if (!newToken) {
                    return throwError(() => new Error('Session expired'));
                }
                const cloned = req.clone({
                    setHeaders: { Authorization: `Bearer ${newToken}` }
                });
                return next(cloned);
            } else {
                sessionService.stopHeartbeat?.();
                setTimeout(() => {
                    authGuard.logout();
                }, 200);
                inMemoryStorageService.delete('userProfile');
                inMemoryStorageService.delete('accessToken');
                setTimeout(() => {
                    router.navigate(['/login']);
                }, 400);
                // Never send /m3 (or any secured) calls without Bearer — that yields 401 "Missing Authorization".
                return throwError(() => new Error('Session expired'));
            }
        })
    );
};

// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//     const refreshTokenService = inject(RefreshTokenService);
//     const sessionService = inject(SessionService);
//     const authGuard = inject(AuthGuard);
//     const router = inject(Router);
//     const inMemoryStorageService = inject(InMemoryStorageService);
//     // Exclude login and refresh endpoints from token logic
//     if (req.url.includes('/login') || req.url.includes('/refresh-token')) {
//         return next(req);
//     }

//     // Update last route time for every request
//     localStorage.setItem(LAST_ROUTE_KEY, Date.now().toString());

//     const accessToken = localStorage.getItem('auth_token');

//     function isTokenExpired(token: string): boolean {
//         try {
//             const payload = JSON.parse(atob(token.split('.')[1]));
//             const issuedAt = payload.iat; // issued at time (in seconds)
//             const oneMinute = 1 * 60; // 1 minute in seconds
//             const simulatedExpiry = issuedAt + oneMinute;

//             const nowSec = Math.floor(Date.now() / 1000);
//             const remainingSeconds = simulatedExpiry - nowSec;
//             const remainingMinutes = (remainingSeconds / 60).toFixed(2);

//             console.log('🔐 JWT Payload:', payload);
//             console.log(`🕒 Simulated token will expire in: ${remainingSeconds}s (${remainingMinutes} mins)`);

//             return remainingSeconds <= 0;
//             // For production, use: return payload.exp <= nowSec;
//         } catch {
//             return true;
//         }
//     }

//     // If token exists and is NOT expired, proceed as normal
//     if (accessToken && !isTokenExpired(accessToken)) {
//         const cloned = req.clone({
//             setHeaders: { Authorization: `Bearer ${accessToken}` }
//         });
//         return next(cloned);
//     }

//     // If token expired, try refresh (only if last route < 1 hour)
//     const lastRouteTimeStr = localStorage.getItem(LAST_ROUTE_KEY);
//     const lastRouteTime = lastRouteTimeStr ? parseInt(lastRouteTimeStr, 10) : 0;
//     const now = Date.now();
//     const diffHours = (now - lastRouteTime) / (1000 * 60 * 60);
//     const diffMinutes = (now - lastRouteTime) / (1000 * 60); // difference in minutes

//     console.log(`🕒 Time since last route: ${diffHours} mins`);

//     console.log(`🕒 Time since last route: ${diffMinutes} mins`);
//     console.log(1 - diffMinutes);
//     console.log(diffMinutes < 0.5);

//     // if (diffHours < 1) {
//     if (diffMinutes > 0.5) {
//         console.log(`🕒1234 Time since last route: ${diffHours} mins`);

//         return from(refreshTokenService.refreshToken()).pipe(
//             switchMap((success) => {
//                 if (success) {
//                     const newToken = localStorage.getItem('auth_token');
//                     const cloned = req.clone({
//                         setHeaders: { Authorization: `Bearer ${newToken}` }
//                     });
//                     return next(cloned);
//                 } else {
//                     console.log('No valid token found, logging out');
//                     sessionService.stopHeartbeat?.();
//                     setTimeout(() => {
//                         authGuard.logout();
//                     }, 200);

//                     // Clean up local session info even before logout happens
//                     inMemoryStorageService.delete('userProfile');
//                     inMemoryStorageService.delete('accessToken');

//                     setTimeout(() => {
//                         router.navigate(['/login']);
//                     }, 400);
//                     // Always return an Observable, never return false
//                     return next(req);
//                 }
//             })
//         );
//     }

//     console.log('No valid token found, logging out');
//     sessionService.stopHeartbeat?.();
//     setTimeout(() => {
//         authGuard.logout();
//     }, 200);

//     // Clean up local session info even before logout happens
//     inMemoryStorageService.delete('userProfile');
//     inMemoryStorageService.delete('accessToken');

//     setTimeout(() => {
//         router.navigate(['/login']);
//     }, 400);
//     // Always return an Observable, never return false
//     return next(req);
// };
